export default "__VITE_ASSET__C4zzfY2K__"